import { useEffect, useRef } from "react";
import { UseFormGetValues } from "react-hook-form";

import { DEFAULT_PRESCRIPTION_VALUES } from "src/constants/addCase";

import { AddCaseProps } from "src/pages/addCase/types";
import { PrescriptionObjKeyProps } from "src/types/case";




export function usePageTrackingAndStorage(fetchLatestData: UseFormGetValues<AddCaseProps>, isDirty: boolean, step: number) {
  const stepRef = useRef(step)

  const isPrescriptionAttributesUpdated = () => {
    const updatedPrescriptionValues = fetchLatestData("prescription_attributes")
    return Object.keys(updatedPrescriptionValues).some((key: unknown) => {
      if (key === "cp_diuretics" || key === "diagnosis_code")
        return false
      else
        return updatedPrescriptionValues[key as PrescriptionObjKeyProps] !== DEFAULT_PRESCRIPTION_VALUES[key as PrescriptionObjKeyProps]
    });
  }

  // Handle page refresh / close
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (isPrescriptionAttributesUpdated() || isDirty)
        localStorage.setItem('newCase', JSON.stringify({ newData: fetchLatestData(), step: stepRef.current }))
    };

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      // Save to localStorage on route change
      handleBeforeUnload()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    stepRef.current = step;
  }, [step]);
};
